import moment from 'moment';
import storage from '@/utils/IDC/storage';
moment.locale('zh-CN');
// const menuitems = state => state.menu.items;
const menuitems = state => {
  let menus = ('menu' in localStorage && localStorage.menu !== '') ? JSON.parse(localStorage.menu) : [];
  return menus
};
// function loopMenu(menus, menusObj) {
//   for (var i = 0; i < menus.length; i++) {
//     if(menus[i].meta.perm) {
//       menusObj[menus[i].meta.perm] = true
//     }
//     if (menus[i].children) {
//       loopMenu(menus[i].children, menusObj)
//     }
//   }
//   return menusObj
// }
function loopMenu(menus, menusObj) {
  for (var i = 0; i < menus.length; i++) {
    if(menus[i].perm) {
      menusObj[menus[i].perm] = true
    }
    if (menus[i].children) {
      loopMenu(menus[i].children, menusObj)
    }
  }
  return menusObj
}
const menuObjects = state => {
  // let menus = state.menu.items
  let menus = ('menu' in localStorage && localStorage.menu !== '') ? JSON.parse(localStorage.menu) : [];
  let menusObj = loopMenu(menus, {})
  return menusObj
}
const menuPerms = state => {
  let perms = ('perms' in localStorage && localStorage.perms !== '') ? JSON.parse(localStorage.perms) : [];
  let obj = {}
  for (var i = 0; i < perms.length; i++) {
    obj[perms[i].perm] = true
  }
  return obj;
}
const getPermObj = state => {return state.common.permObj} // 获取角色权限
const deviceList = state => {return state.common.deviceList}
const isKeyLogin = state => {return state.common.isKeyLogin}
const dataTypes = state => {
  return {
    business_type:'经济类型',
    industry_type:'行业类别',
    cert_type:'身份类型',
    rent_type:'出租类型',
    //room_source:'房屋来源',
    //check_type:'检查类型',
    country_code:'国家字典',
    equipmentType:'设备类型',
    //education:'学历字典',
    platform_name:'平台名称',
    //penalty_amount:'罚单金额',
    open_type:'开锁方式',
    capture_type:'抓拍事件',
    personWorkType:'职业类型',
    //source_of_controlled_objects:'布控对象',
    //zdPersonLevel:'重点人管控级别',
    nationality:'民族',
    monitor_type:'监控类型',
    doorbell_model:'门铃设备类型',
    project_name: '项目'
  }

}
const dataTypesArr = state => {
  let data = dataTypes(state)
  return Object.keys(data).map(function(key) {
    let obj = {
      text: data[key],
      value: key,
    }
    return obj;
  });
}
const policeCaseType = state => {
  return {
    'AB_JZ_ASJ_B_ASJ_JQ|J': '警情信息案别',
    'JQLB_JZ_ASJ_B_ASJ_JQ|J': '警情信息类别',
    'SLJJDW_JZ_ASJ_B_ASJ_JQ|J': '警情信息接警单位',
    'AJLXDM-JZ_ASJ_B_ASJ_AJ_NEW|A': '案件类型',
    'JQLB_JZ_ASJ_B_ASJ_JQ|A': '案件类别'
  }
}
const policeCaseTypeArr = state => {
  let data = policeCaseType(state)
  return Object.keys(data).map(function(key) {
    let obj = {
      text: data[key],
      value: key,
    }
    return obj;
  })
};
const pickerOptions = state => {
  return {
    shortcuts: [{
      text: '今天',
      onClick(picker) {
        // const end = new Date()
        // const start = new Date()
        picker.$emit('pick', [moment().startOf('days')._d, moment().endOf('days')._d])
      }
    },{
      text: '昨天',
      onClick(picker) {
        // const end = new Date()
        // const start = new Date()
        // start.setTime(start.getTime() - 3600 * 1000 * 24)
        picker.$emit('pick', [moment().subtract(1, 'days').startOf('days')._d, moment().subtract(1, 'days').endOf('days')._d])
      }
    },
      {
        text: '本周',
        onClick(picker) {
          picker.$emit('pick', [moment().startOf('week').startOf('days')._d, moment().endOf('week').endOf('days')._d])
        }
    },{
      text: '最近一周',
      onClick(picker) {
        const end = new Date()
        const start = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
        picker.$emit('pick', [start, end])
      }
    }, {
      text: '最近一个月',
      onClick(picker) {
        const end = new Date()
        const start = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
        picker.$emit('pick', [start, end])
      }
    }, {
      text: '最近三个月',
      onClick(picker) {
        const end = new Date()
        const start = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
        picker.$emit('pick', [start, end])
      }
    }]
  }
}

// 是否显示信息中心弹窗
const infoCenterShow = state => state.common.infoCenterShow

const isVerifyControlPersonOperation = state => state.common.isVerifyControlPersonOperation
const areas = state => {
  let data = storage.get('areas')?storage.get('areas'):[]; // 所有地域词典
  return data
};

export default {
  dataTypes,
  dataTypesArr,
  policeCaseType,
  policeCaseTypeArr,
  menuObjects,
  menuitems,
  menuPerms,
  pickerOptions,
  getPermObj,
  infoCenterShow,
  deviceList,
  isKeyLogin,
  isVerifyControlPersonOperation,
  areas
}
